<template>
  <v-sheet class="accent2 pb-6"
           :style="!this.showScrollableList ? 'width: 20%;' : 'width:40vw;' "
  >

    <v-scale-transition>
      <v-img
          class="mb-1 flex-grow-0 cart-item-image rounded mt-auto mx-auto mx-md-0"
          :src="item.hasOwnProperty('image_url') && item.image_url.length > 0 ? item.image_url[0] : noImageSrc"
          :alt="item.title"
          min-width="124"
          style="width:80%; height:28vh;"
          :min-height="50"
          max-height="300"
          contain
          position="center bottom"
      >
      </v-img>
    </v-scale-transition>
    <v-card flat class="mx-auto mx-md-0" color="transparent" style="width:80%;">
      <v-card-title class="mt-2 text-caption omitted body-2 ml-0 mr-auto ml-md-auto"
                    :style="!this.showScrollableList ? 'width:100%;' : 'width:fit-content;'">
        {{ item.title }}
      </v-card-title>
      <buy-price
          :apiForEstimatePrice="apiForEstimatePrice"
          :isbn="item.isbnCode10"
          :isBubble="showSpeechBubble"
          class="text-caption mx-auto ml-0"
          :assessed-price="item.estimatePrice"
      >買取参考価格
      </buy-price>
    </v-card>

  </v-sheet>
</template>


<script>
import BuyPrice from "./item/buy-price.vue";

export default {
  name: "vb-item-estimate-price",
  components: {
    BuyPrice,
  },
  data() {
    return {
      noImageSrc: VueConfig.cdn_url + '/assets/images/common/no_image_bg_straight.svg',
      apiForEstimatePrice: VueConfig.estimate_url,
      cdnUrl: VueConfig.cdn_url,
    }
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    showSpeechBubble: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    showScrollableList() {
      return this.$vuetify.breakpoint.xs;
    },
  }
}
</script>

<style scoped lang="scss">
.text-caption {
  align-self: baseline;
  padding-left: 8px;
  width: 8rem;

  ::v-deep .speech-bubble.left-sp.is-active dd.bubble-contents {
    max-width: 350px;
    min-width: 200px;
    left: -12vw;
  }
}

</style>
